import { createContext, useContext } from 'react';

import { enSearchParams } from 'types/enums';
import { IProduct, ISelectedProduct } from 'types/interfaces';

export interface IContextProps {
  isInitialized?: boolean;
  isEmptyProductList?: boolean;
  products: IProduct[];
  multipleSelection?: boolean;
  selectedProducts: ISelectedProduct[];
  disabledSelectionProducts?: ISelectedProduct[];
  selectionProducts: ISelectedProduct[];
  maxSelectedProducts?: number;
  isFetchingNextPage: boolean;
  totalProducts?: number;
  isFetchingByTerm: boolean;
  termSearch: enSearchParams;
  onSelectProduct: (selectedProduct: ISelectedProduct) => void;
  onToggleHideInvalidProducts?: (hideInvalidProducts: boolean) => void;
  onInView: () => void;
}

const ProductsListContext = createContext<IContextProps | null>(null);

export const useProductsList = () => useContext(ProductsListContext);
export default ProductsListContext;
